

@if (initialized && form && formFields && formGroup) {

  <div class="grid">
    @if(form.uiName) {
      <div class="col-12">
        <h2>{{form.uiName}}</h2>
      </div>
    }

    @if(form.uiDescription) {
      <div class="col-12 py-4 mb-6">
        <p [innerHTML]="form.uiDescription | newline"></p>
      </div>
    }

  </div>

  <form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
    <div class="col-12">

      <div class="grid formgrid p-fluid">

          @for(field of formFields; track field.id) {
            <div class="field mb-4 col-12">
              <label class="font-medium text-900">{{field.uiLabel}} @if(field.uiMandatory){<span style="color:red">*</span> }</label>

              @switch (field.uiInputControl) {
                @case('numberInt') {
                  <p-inputNumber [formControlName]="field.id" [pTooltip]="field.uiDescription" tooltipPosition="bottom"></p-inputNumber>
                }
                @case('numberDecimal') {
                  <p-inputNumber [formControlName]="field.id" [pTooltip]="field.uiDescription" tooltipPosition="bottom"></p-inputNumber>
                }
                @case('singleOption') {
                  <p-dropdown [options]="field.valueList" optionValue="key" optionLabel="label" [formControlName]="field.id" [pTooltip]="field.uiDescription" tooltipPosition="bottom"></p-dropdown>
                }
                @case('select') {
                  <p-dropdown [options]="field.valueList" optionValue="key" optionLabel="label" [formControlName]="field.id" [pTooltip]="field.uiDescription" tooltipPosition="bottom"></p-dropdown>
                }
                @case('date') {
                  <p-calendar [formControlName]="field.id" dateFormat="dd.mm.yy" [pTooltip]="field.uiDescription" tooltipPosition="bottom"></p-calendar>
                }
                @case('textarea') {
                  <textarea [formControlName]="field.id" rows="5" cols="30" pInputTextarea formControlName="text" [pTooltip]="field.uiDescription" tooltipPosition="bottom"></textarea>
                }
                @default {
                  <input type="text" pInputText [formControlName]="field.id" pInputText [pTooltip]="field.uiDescription" tooltipPosition="bottom">
                }
              }


            </div>
          }

      </div>

    </div>
  </form>


}
